import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Divider,
  DialogActions,
  Button,
} from "@mui/material";
import { Question } from "services/KnowfullyAdminClient";
import { FormattedMessage as T } from "react-intl";

type EvaluationPreviewProps = {
  open: boolean;
  title: string;
  questions: Question[];
  onClose: () => void;
};

const EvaluationPreview = ({
  open,
  title,
  questions,
  onClose,
}: EvaluationPreviewProps) => {
  let sequence = 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {questions.map((question) => {
          if (question.questionType?.name === "CategoryHeader") {
            return (
              <Typography key={question.sequence} variant="h6" gutterBottom>
                <div dangerouslySetInnerHTML={{ __html: question.value }} />
              </Typography>
            );
          } else {
            sequence = sequence + 1;
            return (
              <Box key={question.sequence} mb={2}>
                <Box display="flex" mb={1}>
                  <span>{sequence}.&nbsp;</span>
                  <div dangerouslySetInnerHTML={{ __html: question.value }} />
                </Box>
                {!!question?.evaluationQuestionAnswers?.length && (
                  <ol type="A">
                    {question.evaluationQuestionAnswers.map((answer) => (
                      <li key={answer.id}>
                        <div
                          dangerouslySetInnerHTML={{ __html: answer?.value! }}
                        />
                      </li>
                    ))}
                  </ol>
                )}
                {sequence < questions.length && <Divider sx={{ mb: 1 }} />}
              </Box>
            );
          }
        })}
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          <T id="closeButton" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluationPreview;
